import { useEffect, useState, useContext } from 'react'
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import ArticlesSimilaires from '../../components/Product/ArticlesSimilaires';
import Description from '../../components/Product/Description';
import axios from "axios";
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import BankContext from '../../Context/bank';
import CartContext from '../../Context/cart';
import LangContext from '../../Context/lang';







const Product = () => {

  const { Lang, ProductLang, Global,NavMenu } = useContext(LangContext);


  const [searchParams, setSearchParams] = useSearchParams();
  const addto = searchParams.get('add');
  const [ADD, setADD] = useState(false)

  useEffect(() => {

    if (addto === 'yes') {
      setADD(true)
    }
  }, [])

  const navigate = useNavigate();

  const { id } = useParams();
  const url = `https://www.diardzair.com.dz/ws/produit?hash=${id}`;
  // console.log(url)

  const [Quantity, setQuantity] = useState(1)
  const [MaxQuantity, setMaxQuantity] = useState(1)

  const { Cart, AddToCart, Alert, setAlert, MinAmount, MaxAmount, TimeCart } = useContext(CartContext);
  const { bankActive } = useContext(BankContext);

  // console.log(Cart, Alert, MinAmount, MaxAmount, !Number.isInteger(parseInt('')))



  function AddToCartProduct(params) {

    if (!Number.isInteger(parseInt(MaxAmount)) || !Number.isInteger(parseInt(MinAmount)) || (Number(TimeCart) !== 12 && Number(TimeCart) !== 24 && Number(TimeCart) !== 36)) {

      return navigate('/cartsimulation?back=' + id)

    }

    AddToCart({
      "hash": params.hash,
      "nom": params.nom,
      "marque": params.marque,
      "price": params.price,
      "image": params.image,
      "quantité": params.quantité,
      "qtsUnite": params.qtsUnite
    },
    )

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })

  }






  // var images = [
  //   {
  //     original: 'https://www.diardzair.com.dz/uploads/img/2225.webp',
  //     thumbnail: 'https://www.diardzair.com.dz/uploads/img/2225.webp',
  //   },
  //   {
  //     original: 'https://www.diardzair.com.dz/uploads/img/2226.webp',
  //     thumbnail: 'https://www.diardzair.com.dz/uploads/img/2226.webp',
  //   },
  //   {
  //     original: 'https://www.diardzair.com.dz/uploads/img/2227.webp',
  //     thumbnail: 'https://www.diardzair.com.dz/uploads/img/2227.webp',
  //   },
  // ];

  const [Product, setProduct] = useState([]);
  const [PriceProduct, setPriceProduct] = useState({})
  const [images, setImages] = useState([])
  const [Stock, setStock] = useState(1)
  const [Loading, setLoading] = useState(true)
  const [CatProduct, setCatProduct] = useState('')


  useEffect(() => {

    const fetchData = async () => {
      // setLoading(true);
      try {
        const { data: response } = await axios.get(`https://www.diardzair.com.dz/ws/produit?hash=${id}`);
        // console.log(response);
        // console.log(response['product'].length);
        // console.log(response['0']);

        if (response['0'] == "<" || typeof response !== "object" || response['product'].length == 0) {
          navigate('/')
          navigate(0)
        }

        setCatProduct(response['sim'])



        setProduct(response['product']);
        setQuantity(1)
        setMaxQuantity(response['product'][0]['qtsUnite'])
        setPriceProduct(response['sim'])
        setStock(response['product'][0]['stock'])
        // console.log(Stock)
        setLoading(false)

        const imgFilter = [
          response['product'][0]['imageA'] != null ? {
            original: `https://www.diardzair.com.dz/${response['product'][0]['imageA']}`,
            thumbnail: `https://www.diardzair.com.dz/${response['product'][0]['imageA']}`,
          } : '',
          response['product'][0]['imageB'] != null ? {
            original: `https://www.diardzair.com.dz/${response['product'][0]['imageB']}`,
            thumbnail: `https://www.diardzair.com.dz/${response['product'][0]['imageB']}`,
          } : '',
          response['product'][0]['imageC'] != null ? {
            original: `https://www.diardzair.com.dz/${response['product'][0]['imageC']}`,
            thumbnail: `https://www.diardzair.com.dz/${response['product'][0]['imageC']}`,
          } : '',
          response['product'][0]['imageD'] != null ? {
            original: `https://www.diardzair.com.dz/${response['product'][0]['imageD']}`,
            thumbnail: `https://www.diardzair.com.dz/${response['product'][0]['imageD']}`,
          } : '',

        ];

        // console.log(imgFilter);

        setImages(imgFilter.filter(imgslides => imgslides !== ''))

        // console.log(images);



      } catch (error) {
        setLoading(false)
        console.error(error.message);
      }
      // setLoading(false);
    }

    fetchData();

    // axios.get('https://www.diardzair.com.dz/ws/produit?hash=5d7e96e84f868e460df9f988e07d8460').then(response => {
    //       // console.log(response.data[0])
    //       setProduct(response.data[0])
    //       console.log(Product)
    //     });

  }, [id]);



  useEffect(() => {

    if (!Loading && Product.length > 0 && ADD) {

      AddToCartProduct({
        "hash": id,
        "nom": Product[0]['nom'],
        "marque": Product[0]['marque'],
        "price": Math.trunc(Product[0]['prix']),
        "image": Product[0]['imageA'],
        "quantité": Quantity,
        "qtsUnite": Product[0]['qtsUnite']
      },
      )

    }

    // var input = document.querySelector('#qty');
    // var btnminus = document.querySelector('.qtyminus');
    // var btnplus = document.querySelector('.qtyplus');

    // if (input !== undefined && btnminus !== undefined && btnplus !== undefined && input !== null && btnminus !== null && btnplus !== null) {

    //     var min = Number(input.getAttribute('min'));
    //     var max = Number(input.getAttribute('max'));
    //     var step = Number(input.getAttribute('step'));

    //     function qtyminus(e) {
    //         var current = Number(input.value);
    //         var newval = (current - step);
    //         if(newval < min) {
    //             newval = min;
    //         } else if(newval > max) {
    //             newval = max;
    //         } 
    //         input.value = Number(newval);
    //         e.preventDefault();
    //     }

    //     function qtyplus(e) {
    //         var current = Number(input.value);
    //         var newval = (current + step);
    //         if(newval > max) newval = max;
    //         input.value = Number(newval);
    //         e.preventDefault();
    //     }

    //     btnminus.addEventListener('click', qtyminus);
    //     btnplus.addEventListener('click', qtyplus);

    // }
  }, [Loading, Product]);





  return (

    <div className='product-page'>
      <div className='container'>

        {Alert !== '' && Alert.hash == id ?
          <div class={`alert alert-${Alert.flag} alert-dismissible fade show`} role="alert">
            {Alert.msg}. <a href={"/cart"}> <span className='mon-panier'> Mon Panier</span></a>
            <button onClick={() => setAlert('')} type="button" class="btn-close" ></button>
          </div> : ''
        }
      </div>
      <section className='top-content'>
        <div className='container'>
          <div className='product-stock'>
            {Stock == 0 &&
              <div className="alert alert-warning fade show" role="alert">
                <strong>Désolé,</strong>  ce produit est épuisé

              </div>
            }
          </div>
          <div className='product-cat mb-4 mt-3'><a href='/dari3mar'>{(NavMenu['Home'][Lang])}</a> / 
          {CatProduct.parent && <a href={`/search/?page=1&parent=${CatProduct?.parent?.unicnom}`}>{ Lang === "fr" ? CatProduct?.parent?.nom : CatProduct?.parent?.nomAr}</a>  }  / 
          {CatProduct.categorie && <a href={`/search/?page=1&parent=${CatProduct?.parent?.unicnom}&categorie=${CatProduct?.categorie?.unicnom}`}>{Lang === "fr" ? CatProduct?.categorie?.nom : CatProduct?.categorie?.nomAr}</a>}
          </div>
          <div className='row g-0 g-lg-5'>
            <div className='col-12 col-lg-5 mb-5 mb-lg-0'>
              <ImageGallery thumbnailPosition={window.screen.width > 600 ? "left" : 'bottom'} showPlayButton={false} items={images} />
            </div>
            <div className='col-12 col-lg-7'>
              <div className='product-titel'>
                {Product.length > 0 ? Product[0]['nom'] : ''}
                {/* Téléviseur SAMSUNG 43" UA43T5300AUCBM */}
              </div>
              <div className='price-section mt-4'>
                <div className='product-price me-5'>{Product.length > 0 ? Math.trunc(parseInt(PriceProduct['sim36'])) : ''} DA <span>/ mois</span> </div>
                <div className='product-attr'>
                  <div className='product-attr-item me-5'>
                    <svg xmlns="https://www.w3.org/2000/svg" width="43.653" height="27.589" viewBox="0 0 43.653 27.589">
                      <defs>
                        <linearGradient id="linear-gradient" x1="0.572" x2="0.118" y2="1.695" gradientUnits="objectBoundingBox">
                          <stop offset="0" stop-color="#fb4972" />
                          <stop offset="1" stop-color="#ffd6b2" />
                        </linearGradient>
                      </defs>
                      <g id="icon_bottom_liv" data-name="icon bottom liv" transform="translate(-41.126 -62.9)">
                        <path id="Tracé_138" data-name="Tracé 138" d="M84.78,85.625a.957.957,0,0,1-.961.491c-.64-.011-1.27,0-1.943,0a4.369,4.369,0,0,1-1.718,3.448,4.3,4.3,0,0,1-2.69.918,4.449,4.449,0,0,1-4.312-4.344H57.818a4.366,4.366,0,0,1-2,3.64,4.055,4.055,0,0,1-2.8.683,4.431,4.431,0,0,1-3.9-4.323c-.149-.011-.3-.021-.448-.021H45.735a1.492,1.492,0,0,1-1.708-1.686V83.191H42.2a3.229,3.229,0,0,1-.555-.032.562.562,0,0,1-.512-.63,1.2,1.2,0,0,1,.459-.63c.117-.1.352-.064.534-.064h6.052c.534.021.854.288.843.7s-.32.662-.865.672c-.907.011-1.815,0-2.775,0,0,.48-.011.918.011,1.345,0,.075.16.2.246.2,1.174.011,2.359.021,3.533,0,.107,0,.245-.16.3-.278a4.316,4.316,0,0,1,7.845-.171.686.686,0,0,0,.758.47q6.548-.016,13.086-.011H71.7V83.287c0-1.153-.011-2.306.011-3.448a.985.985,0,0,1,.235-.683.75.75,0,0,1,.683-.117.913.913,0,0,1,.416.608c.053.811.021,1.622.021,2.434,0,.779-.011,1.558.011,2.348a1.173,1.173,0,0,0,.128.352c.107-.085.256-.16.31-.278a4.307,4.307,0,0,1,7.877-.117c.139.31.288.438.63.406.438-.032.875-.011,1.324-.011V81.75c-.3,0-.587.011-.865,0a2.1,2.1,0,0,1-2.017-2.028c-.021-.48-.021-.971-.011-1.452.011-.523.256-.769.8-.779.64-.011,1.281,0,1.921,0a2.017,2.017,0,0,0-2-1.537c-1.153-.021-2.306-.011-3.448-.011H73.071c0,.256.011.491,0,.726a.675.675,0,0,1-.64.715.708.708,0,0,1-.715-.694c-.011-.128-.011-.256-.011-.384V64.3H45.372V76.5c-.011.576-.256.9-.694.886-.416-.011-.672-.331-.672-.875V64.576A1.47,1.47,0,0,1,45.681,62.9H71.427a1.442,1.442,0,0,1,1.644,1.644v1.238c.171.011.32.021.47.021h4.472a2.843,2.843,0,0,1,2.978,2.22,4.921,4.921,0,0,1,.064,1.484c-.021.224-.267.427-.459.715.32,1.3.672,2.722,1.035,4.131a.442.442,0,0,0,.256.278A3.579,3.579,0,0,1,84.694,77.6c.011.043.032.075.043.117C84.78,80.33,84.78,82.977,84.78,85.625ZM80.3,74.513c-.342-1.388-.683-2.722-1-4.056a.439.439,0,0,0-.512-.406c-1.751.011-3.49.011-5.241.011-.139,0-.267.021-.395.032v4.419ZM53.569,83.2a2.953,2.953,0,1,0,2.861,3.031A2.966,2.966,0,0,0,53.569,83.2Zm23.984,5.9a2.957,2.957,0,1,0-2.978-2.946A3.007,3.007,0,0,0,77.554,89.1Zm2.209-20.44a2.322,2.322,0,0,0-.075-.438,1.516,1.516,0,0,0-1.59-1.089c-1.548-.011-3.1,0-4.632,0-.107,0-.213.021-.331.032v1.484C75.344,68.664,77.532,68.664,79.763,68.664ZM83.392,80.3V78.825H81.909C81.738,80.138,82.133,80.512,83.392,80.3Z" transform="translate(0 0)" fill="url(#linear-gradient)" />
                        <path id="Tracé_139" data-name="Tracé 139" d="M161.7,130.392c.822-.822,1.612-1.622,2.412-2.412l3.522-3.522c.395-.395.779-.427,1.089-.128s.277.7-.107,1.089c-2.1,2.113-4.216,4.216-6.33,6.33-.427.416-.758.427-1.174.011q-1.729-1.713-3.437-3.437a.713.713,0,0,1-.117-1.057c.3-.31.694-.288,1.089.1.907.9,1.8,1.8,2.711,2.711A4.243,4.243,0,0,1,161.7,130.392Z" transform="translate(-103.835 -54.694)" fill="url(#linear-gradient)" />
                        <path id="Tracé_140" data-name="Tracé 140" d="M210.96,241.377h-4.718a2.753,2.753,0,0,1-.512-.032.622.622,0,0,1-.534-.63.614.614,0,0,1,.491-.662,2.244,2.244,0,0,1,.459-.053h9.617c.128,0,.256.011.384.021a.664.664,0,0,1-.043,1.324c-.139.011-.288.011-.427.011C214.108,241.377,212.529,241.377,210.96,241.377Z" transform="translate(-146.556 -158.197)" fill="url(#linear-gradient)" />
                        <path id="Tracé_141" data-name="Tracé 141" d="M60.337,214.055c-1.42,0-2.839.021-4.259-.021a.934.934,0,0,1-.662-.406.725.725,0,0,1,.107-.683,1.05,1.05,0,0,1,.715-.256c1.281-.021,2.551-.011,3.832-.011h4.344c.128,0,.256,0,.384.011a.7.7,0,0,1,.63.694.674.674,0,0,1-.7.651c-.438.011-.875.011-1.324.011C62.386,214.055,61.362,214.055,60.337,214.055Z" transform="translate(-12.723 -133.788)" fill="url(#linear-gradient)" />
                        <path id="Tracé_142" data-name="Tracé 142" d="M145,267.6a1.377,1.377,0,0,1,1.409,1.388,1.392,1.392,0,0,1-1.388,1.42A1.4,1.4,0,1,1,145,267.6Z" transform="translate(-91.536 -182.849)" fill="url(#linear-gradient)" />
                        <path id="Tracé_143" data-name="Tracé 143" d="M369.1,268.909a1.4,1.4,0,0,1,2.807-.011,1.429,1.429,0,0,1-1.4,1.42A1.408,1.408,0,0,1,369.1,268.909Z" transform="translate(-292.966 -182.761)" fill="url(#linear-gradient)" />
                      </g>
                    </svg>
                    <p>{(ProductLang['Livraison'][Lang])}</p>
                  </div>
                  <div className='product-attr-item mt-3 mt-md-0 d-none'>
                    <svg xmlns="https://www.w3.org/2000/svg" width="31.702" height="31.713" viewBox="0 0 31.702 31.713">
                      <defs>
                        <linearGradient id="linear-gradient" x1="0.572" x2="0.118" y2="1.695" gradientUnits="objectBoundingBox">
                          <stop offset="0" stop-color="#fb4972" />
                          <stop offset="1" stop-color="#ffd6b2" />
                        </linearGradient>
                      </defs>
                      <g id="paiment" transform="translate(-86.4 -21.987)">
                        <path id="Tracé_144" data-name="Tracé 144" d="M135.511,32.7a.844.844,0,0,1-.841.44c-1.74-.019-3.489,0-5.229-.01a.459.459,0,0,0-.43.21,4.981,4.981,0,0,1-3.069,2.046,2.391,2.391,0,0,1-.736.048.849.849,0,0,0-.727.287q-2.9,2.925-5.813,5.832c-.449.449-.755.449-1.2.01L106.037,30.134c-.516-.516-.516-.746,0-1.262l6.52-6.52c.488-.488.746-.488,1.243.01.574.574,1.147,1.138,1.7,1.711a.385.385,0,0,0,.478.115c1.013-.373,2.027-.774,3.059-1.071a4.609,4.609,0,0,1,3.346.287c1.377.66,2.715,1.386,4.063,2.094a3.509,3.509,0,0,0,1.769.516c.01-.038.029-.086.038-.134.057-.43.249-.621.688-.621.535-.01,1.071,0,1.654,0,0-.191-.01-.354,0-.507a.593.593,0,0,1,.641-.641c1.2-.01,2.419,0,3.623,0a.725.725,0,0,1,.65.44C135.511,27.247,135.511,29.971,135.511,32.7Zm-18.824-7.457c.774.774,1.52,1.53,2.275,2.275a.532.532,0,0,0,.249.105l2.352.746c.621.2,1.243.382,1.855.6a.594.594,0,0,1,.382.774.633.633,0,0,1-.746.4c-.086-.019-.182-.057-.268-.086q-2.624-.832-5.239-1.654a1.2,1.2,0,0,0-1.405.5,1.16,1.16,0,0,0,.191,1.5,2.422,2.422,0,0,0,.841.5c1.5.535,3.021,1.023,4.532,1.558a1.637,1.637,0,0,1,.631.44,3.555,3.555,0,0,0,3.595,1.2,3.719,3.719,0,0,0,2.256-1.769.482.482,0,0,0,.057-.268c0-1.52,0-3.031.01-4.551,0-.2-.057-.268-.258-.287a5.226,5.226,0,0,1-2.084-.631c-1.319-.688-2.639-1.4-3.977-2.055a3.682,3.682,0,0,0-2.83-.191C118.3,24.618,117.519,24.933,116.687,25.239ZM109.5,31.75c2.1,2.1,4.2,4.207,6.31,6.31a3.8,3.8,0,0,1,2.256-.7,3.928,3.928,0,0,1,2.237.7l1.424-1.424a3.962,3.962,0,0,1-.65-2.887c.01-.076-.038-.22-.1-.239-.641-.229-1.281-.44-1.941-.669-.048.134-.086.239-.124.344a3.525,3.525,0,1,1-4.2-4.665.753.753,0,0,0,.373-.268,2.562,2.562,0,0,1,1.434-1.071c.086-.029.163-.057.239-.076-.44-.44-.86-.86-1.3-1.291h-.01a3.966,3.966,0,0,1-4.455.048.276.276,0,0,0-.229.029c-.44.421-.87.851-1.291,1.272A4.075,4.075,0,0,1,109.5,31.75Zm24.751.124V25.335h-2.4v6.539Zm-19.522-2.008a2.235,2.235,0,0,0-1.377,2.524,2.3,2.3,0,0,0,2.438,1.836,2.165,2.165,0,0,0,1.989-1.816C116.4,32.017,115.033,31.568,114.727,29.866Zm14.78-3.365v5.373h1.061V26.5Zm-12.8,12.476,1.338,1.338,1.338-1.338A2.546,2.546,0,0,0,116.706,38.977Zm-8.136-10.822c-.468.468-.918.927-1.348,1.348.44.43.889.889,1.348,1.338A2.523,2.523,0,0,0,108.571,28.155Zm4.541-4.656-.65.679c-.229.229-.468.449-.707.679a2.526,2.526,0,0,0,2.744.038C114.058,24.446,113.609,24,113.112,23.5Zm9.465,12.228c.268-.229.5-.43.717-.631-.344-.182-.679-.363-1.1-.593C122.347,34.991,122.471,35.383,122.576,35.727Z" transform="translate(-17.41)" fill="url(#linear-gradient)" />
                        <path id="Tracé_145" data-name="Tracé 145" d="M101.132,235.276a18.347,18.347,0,0,1-5.411-2.409,4.8,4.8,0,0,0-1.75-.66,2.518,2.518,0,0,0-.268-.019c-.153.707-.258.794-.985.794H91.314c0,.182.01.344,0,.507a.585.585,0,0,1-.621.631c-1.224.01-2.457.01-3.681,0a.58.58,0,0,1-.612-.641v-7.734c0-.44.258-.66.755-.66H90.74c.574,0,1.157-.01,1.73,0a.467.467,0,0,0,.43-.22,4.721,4.721,0,0,1,7.5-.478,1.267,1.267,0,0,0,.421.287c1.358.468,2.725.927,4.092,1.386a3.116,3.116,0,0,1,2.17,1.855c.794-.22,1.6-.44,2.4-.66l2.17-.6a2.51,2.51,0,0,1,3.126,1.2,2.3,2.3,0,0,1-.258,2.61,3.224,3.224,0,0,1-1.463,1.052c-3.231,1.157-6.453,2.323-9.685,3.47a12.143,12.143,0,0,1-1.2.306C101.84,235.276,101.486,235.276,101.132,235.276Zm-7.476-4.321A6.29,6.29,0,0,1,96.7,232c1.061.593,2.151,1.128,3.241,1.663a4.034,4.034,0,0,0,1.711.382,4.862,4.862,0,0,0,1.826-.43c3.05-1.1,6.109-2.189,9.159-3.3a2.713,2.713,0,0,0,.86-.574,1.035,1.035,0,0,0,.306-1.023,1.24,1.24,0,0,0-1.73-.9q-2.352.645-4.7,1.31a.472.472,0,0,0-.268.239,2.44,2.44,0,0,1-3.193,1.587c-1.042-.325-2.084-.66-3.126-.985-.746-.239-1.491-.468-2.237-.707a.606.606,0,0,1-.459-.65.573.573,0,0,1,.5-.545,1.052,1.052,0,0,1,.449.067c.918.287,1.826.574,2.744.87.851.268,1.7.545,2.562.813a1.2,1.2,0,0,0,1.444-.526,1.182,1.182,0,0,0-.277-1.539,2.529,2.529,0,0,0-.8-.44c-1.511-.526-3.021-1.023-4.532-1.558a1.386,1.386,0,0,1-.583-.411,3.556,3.556,0,0,0-3.489-1.252,3.7,3.7,0,0,0-2.381,1.8.728.728,0,0,0-.057.354v4.369C93.656,230.7,93.656,230.8,93.656,230.955Zm-3.6,1.912v-6.53h-2.4v6.53Zm1.291-6.539v5.392h1.052v-5.392Z" transform="translate(0 -181.586)" fill="url(#linear-gradient)" />
                        <path id="Tracé_146" data-name="Tracé 146" d="M307.331,102.71a.61.61,0,0,1-.612.612.623.623,0,0,1-.621-.6.616.616,0,0,1,.631-.621A.6.6,0,0,1,307.331,102.71Z" transform="translate(-198.694 -72.451)" fill="url(#linear-gradient)" />
                        <path id="Tracé_147" data-name="Tracé 147" d="M185.4,271.3a.6.6,0,0,1,.612-.6.629.629,0,0,1,.621.6.617.617,0,1,1-1.233,0Z" transform="translate(-89.535 -224.935)" fill="url(#linear-gradient)" />
                      </g>
                    </svg>

                    <p>Paiement	<br />Mourabaha</p>
                  </div>


                </div>
              </div>
              <div className='product-mark mt-4'> <span>{(ProductLang['Marque'][Lang])} :</span> {Product.length > 0 ? Product[0]['marque'] : ''}</div>
              {/* {Product.length > 0 && Product[0]['descriptionShort'] ?
                <div className='product-desc'> <span>Descriptif :</span>
                <div
                  dangerouslySetInnerHTML={{
                    __html: Product[0]['descriptionShort']
                  }}></div>
              </div> : ''} */}
              {Product.length > 0 && Product[0]['ref'] ? <div className='product-desc'> <span>{(ProductLang['Ref'][Lang])} : </span> {Product[0]['ref']} </div> : ''}
              {Stock > 0 &&
                <div className='product-purchase mt-4'>
                  <div className='product-q-p'>
                     

                    <div onClick={() => navigate('/dari3mar/simulation/'+id)} className='sell-btn'> {(ProductLang['Jefaisunesimulation'][Lang])}
                      <svg xmlns="https://www.w3.org/2000/svg" width="23.417" height="21.964" viewBox="0 0 23.417 21.964">
                        <g id="_270-2708173_cart-add-512x512-icon-online-shopping" data-name="270-2708173_cart-add-512x512-icon-online-shopping" transform="translate(-669.8 -330.1)">
                          <path id="Tracé_148" data-name="Tracé 148" d="M669.8,354.018c.238-.4.408-.463.848-.316l2.911.976c.39.128.472.248.509.665.073.857.151,1.719.229,2.595.578.087,1.142.17,1.705.257,1.284.188,2.567.38,3.851.564a.6.6,0,0,1,.555.371.538.538,0,0,1-.623.706c-.743-.105-1.481-.22-2.219-.33-.976-.147-1.948-.289-2.925-.431-.073-.009-.147-.014-.252-.023.028.339.05.656.092.972,0,.046.119.1.183.11,1.357.211,2.719.422,4.076.628l10.393,1.582c.651.1,1.3.193,1.948.3.16.027.234-.009.266-.174.06-.289.147-.573.229-.885l-1.123-.17c-1.036-.156-2.068-.307-3.1-.458a.536.536,0,0,1-.513-.628.526.526,0,0,1,.665-.431q1.939.282,3.874.573c.481.073.477.078.605-.4.055-.206.105-.413.165-.619.083-.293.248-.454.5-.463a.521.521,0,0,1,.536.348.22.22,0,0,0,.041.05v.229c-.028.087-.064.17-.087.257q-1,3.789-2.008,7.573c-.147.559-.243.633-.83.633H674.824c-.105,0-.215,0-.321,0a1.065,1.065,0,0,0-.156,2.1,1.931,1.931,0,0,0,.431.027h15.56a1.839,1.839,0,0,1,.275.009.535.535,0,0,1-.11,1.064c-.417.009-.834,0-1.284,0,.046.11.073.183.105.261a2.145,2.145,0,0,1-1.527,2.9c-.087.018-.174.041-.266.064h-.367a1.058,1.058,0,0,0-.128-.041,2.139,2.139,0,0,1-1.623-3c.023-.05.037-.11.06-.17h-7.427c.037.092.069.16.1.229a2.143,2.143,0,0,1-1.531,2.916c-.087.018-.179.041-.266.06h-.321c-.05-.014-.1-.032-.151-.041a2.14,2.14,0,0,1-1.627-3.007c.027-.06.046-.119.073-.179a2.169,2.169,0,0,1-.321-4.218c0-.073,0-.138,0-.2q-.475-5.515-.949-11.026a.278.278,0,0,0-.225-.289c-.834-.271-1.664-.559-2.5-.83a.783.783,0,0,1-.527-.431ZM675.081,367h.27q7.276,0,14.551,0c.183,0,.261-.041.312-.229.234-.926.486-1.848.729-2.769.023-.092.046-.188.078-.3-5.492-.839-10.952-1.673-16.444-2.508C674.746,363.145,674.911,365.053,675.081,367Zm2.168,5.355a1.064,1.064,0,1,0-1.059,1.068A1.07,1.07,0,0,0,677.249,372.356Zm10.122,1.064a1.066,1.066,0,1,0-1.073-1.05A1.054,1.054,0,0,0,687.372,373.419Z" transform="translate(0 -22.451)" fill="#fff" />
                          <path id="Tracé_149" data-name="Tracé 149" d="M905.713,330.1a1.487,1.487,0,0,1,.229.183.486.486,0,0,1,.105.532.491.491,0,0,1-.44.348c-.183.018-.367.023-.546.055a2.673,2.673,0,1,0,3.113,3.072c.023-.142.027-.289.037-.436a.534.534,0,1,1,1.064.055,3.6,3.6,0,0,1-2,3.246,3.718,3.718,0,0,1-5.313-4.241,3.606,3.606,0,0,1,2.984-2.76c.073-.014.147-.032.22-.05C905.346,330.1,905.53,330.1,905.713,330.1Z" transform="translate(-221.381)" fill="#fff" />
                          <path id="Tracé_150" data-name="Tracé 150" d="M950.716,379.035v.316c0,.5-.174.752-.523.756s-.536-.252-.536-.77v-.3c-.179,0-.335,0-.491,0a.535.535,0,1,1,.009-1.068c.151,0,.3,0,.486,0,0-.188,0-.353,0-.518a.53.53,0,1,1,1.059.009c0,.16,0,.316,0,.5.179,0,.335,0,.5,0a.533.533,0,0,1,.568.532.52.52,0,0,1-.555.536C951.065,379.04,950.9,379.035,950.716,379.035Z" transform="translate(-266.017 -44.653)" fill="#fff" />
                        </g>
                      </svg>
                    </div>
                    
                  </div>
                  <a className='d-none' href='/assistence'>
                    <div className='call-btn'>Commande Par Tel
                      <svg xmlns="https://www.w3.org/2000/svg" width="19.964" height="19.964" viewBox="0 0 19.964 19.964">
                        <path id="icons8-phone" d="M8.687,6A2.694,2.694,0,0,0,6,8.687V23.276a2.694,2.694,0,0,0,2.687,2.687H23.276a2.694,2.694,0,0,0,2.687-2.687V8.687A2.694,2.694,0,0,0,23.276,6Zm0,.768H23.276a1.916,1.916,0,0,1,1.92,1.92V23.276a1.916,1.916,0,0,1-1.92,1.92H8.687a1.916,1.916,0,0,1-1.92-1.92V8.687A1.916,1.916,0,0,1,8.687,6.768Zm3,1.156a1.25,1.25,0,0,0-.724.288A3.511,3.511,0,0,0,9.9,9.507a4.11,4.11,0,0,0,.345,3.787.384.384,0,0,0,.039.055,18.328,18.328,0,0,0,8.3,8.31.384.384,0,0,0,.087.068,4.11,4.11,0,0,0,3.787.346h0a3.507,3.507,0,0,0,1.3-1.058A1.262,1.262,0,0,0,23.5,19.17h0l-2.584-1.744a1.236,1.236,0,0,0-1.464.064h0l-.942.763a15.873,15.873,0,0,1-4.789-4.786l.769-.95a1.234,1.234,0,0,0,.064-1.464L12.8,8.468a1.241,1.241,0,0,0-.865-.535A1.284,1.284,0,0,0,11.683,7.924Zm.052.761a.478.478,0,0,1,.433.213l1.743,2.584h0a.457.457,0,0,1-.024.551l-.951,1.174a.384.384,0,0,0-.029.442,16.605,16.605,0,0,0,5.413,5.411.384.384,0,0,0,.442-.029l1.166-.944a.459.459,0,0,1,.552-.025l2.585,1.744a.482.482,0,0,1,.1.716,3.087,3.087,0,0,1-.994.838,3.2,3.2,0,0,1-3.061-.274h0a.384.384,0,0,0-.087-.058,17.605,17.605,0,0,1-8.088-8.089.384.384,0,0,0-.03-.051,3.206,3.206,0,0,1-.289-3.094,3.09,3.09,0,0,1,.838-.994A.5.5,0,0,1,11.735,8.685ZM9.613,15.062a.387.387,0,0,0-.144.05l-.659.394a.384.384,0,0,0,.394.659l.659-.394a.384.384,0,0,0-.25-.709Zm1.2,1.623a.38.38,0,0,0-.285.072l-.616.458a.384.384,0,0,0,.458.616l.616-.459a.383.383,0,0,0-.173-.687Zm1.2,1.508a.385.385,0,0,0-.277.1l-.568.517a.384.384,0,1,0,.516.568l.568-.517a.384.384,0,0,0-.24-.667Zm1.348,1.383a.384.384,0,0,0-.266.125l-.516.568a.384.384,0,1,0,.568.516l.517-.568a.384.384,0,0,0-.3-.641Zm1.473,1.248a.384.384,0,0,0-.253.15l-.459.616a.384.384,0,0,0,.616.459l.459-.616a.384.384,0,0,0-.363-.609Zm1.732,1.087a.385.385,0,0,0-.383.183l-.394.658a.384.384,0,0,0,.659.394l.394-.659a.382.382,0,0,0-.276-.577Z" transform="translate(-6 -6)" fill="#fff" />
                      </svg>

                    </div></a>
                </div>}


              <div className='product-taksit-section mt-5'>
                <div className='taksit-titel'><p> تقسـيط </p><span class="line"></span></div>
                <div className='product-taksit-bank'>
                <div className='product-taksit-list-price mt-4'>
                  <p>{Product.length > 0 ? Math.trunc(parseInt(PriceProduct['sim36'])) : ''} DA <span className='product-mounth'> / mois  </span>   <span className='product-mounth-time'> jusqu'à 36 mois</span></p>
                  <p>{Product.length > 0 ? Math.trunc(parseInt(PriceProduct['sim24'])) : ''} DA <span className='product-mounth'> / mois  </span>    <span className='product-mounth-time'> jusqu'à 24 mois</span></p>
                  <p>{Product.length > 0 ? Math.trunc(parseInt(PriceProduct['sim12'])) : ''} DA <span className='product-mounth'> / mois  </span>     <span className='product-mounth-time'> jusqu'à 12 mois</span></p>
                </div>
                <div className='bank-img-simulation ms-5'>
                  <img src={'/img/' + bankActive + '.png'} />
                </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <section className='bg-product'>
        <ArticlesSimilaires id={id} />
        <Description desc={Product.length > 0 ? Product[0]['descriptionShort'] : ''} charac={Product.length > 0 ? Product[0]['description'] : ''} />
      </section>


    </div>
  )
}

export default Product